import React from 'react'
import { useLocation } from 'react-router-dom'

const AnalyticsListener = () => {
  const location = useLocation()
  React.useEffect(
    () => {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'page_view', {
          page_location: window.location.href,
          page_path: location.pathname + location.search,
          page_title: document.title
        })
      }
    },
    [location.pathname, location.search]
  )

  return null
}

export default AnalyticsListener
